import request from '@/utils/request'

export function getPhysicalOilCompanyFleetCardVehicles(branchId, size, page, find, dates, dateType) {
  return request({
    url: `/mydiesel/physicaloilcompanyfleetcardvehicle/${branchId}`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find,
      startDate: dates,
      dateType: dateType
    }
  })
}

export function getPhysicalOilCompanyFleetCardVehicleById(branchId, id) {
  return request({
    url: `/mydiesel/physicaloilcompanyfleetcardvehicle/id/${branchId}/${id}`,
    method: 'get'
  })
}

export function findPhysicalOilCompanyFleetCardVehicles(branchId, find) {
  return request({
    url: `/mydiesel/physicaloilcompanyfleetcardvehicle/list/${branchId}`,
    method: 'get',
    params: {
      find: find
    }
  })
}

export function createPhysicalOilCompanyFleetCardVehicles(branchId, data) {
  return request({
    url: `/mydiesel/physicaloilcompanyfleetcardvehicle/create/${branchId}`,
    method: 'post',
    data
  })
}

export function oilcompanyInProgressPhysicalOilCompanyFleetCardVehicles(branchId, id) {
  return request({
    url: `/mydiesel/physicaloilcompanyfleetcardvehicle/oilcompanyInProgress/${branchId}/${id}`,
    method: 'post'
  })
}

export function oilcompanyDeliveredPhysicalOilCompanyFleetCardVehicles(branchId, id) {
  return request({
    url: `/mydiesel/physicaloilcompanyfleetcardvehicle/oilcompanyDelivered/${branchId}/${id}`,
    method: 'post'
  })
}

export function duplicatePhysicalOilCompanyFleetCardVehicles(branchId, id) {
  return request({
    url: `/mydiesel/physicaloilcompanyfleetcardvehicle/duplicate/${branchId}/${id}`,
    method: 'post'
  })
}

export function updatePhysicalOilCompanyFleetCardVehicles(branchId, id, data) {
  return request({
    url: `/mydiesel/physicaloilcompanyfleetcardvehicle/id/${branchId}/${id}`,
    method: 'put',
    data
  })
}

export function removePhysicalOilCompanyFleetCardVehicles(branchId, id) {
  return request({
    url: `/mydiesel/physicaloilcompanyfleetcardvehicle/id/${branchId}/${id}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/mydiesel/mydieselPhysicalOilCompanyFleetCardVehicles.js